import React from "react";
import PropTypes from "prop-types";

import { default as ReactPhoneInput } from "react-phone-input-2";

import "./styles.scss";

const propTypes = {
    phone: PropTypes.string,
    setCountry: PropTypes.func,
    setPhone: PropTypes.func,
};

const PhoneInput = ({ phone, setCountry, setPhone }) => {
    return (
        <div className="phone-input">
            <ReactPhoneInput
                preferredCountries={["cl", "us", "br", "mx", "es"]}
                masks={{
                    cl: ". .... ....",
                    us: "(...) ... ....",
                    br: ".. ..... ....",
                    mx: ".. .. .... ....",
                    es: ".. ... .. ..",
                    cn: "... .... ....",
                    ar: "... ....-....",
                }}
                countryCodeEditable={false}
                value={phone}
                onChange={(value, countryData) => {
                    setPhone(value);
                    if (setCountry) setCountry(countryData.countryCode);
                }}
            />
        </div>
    );
};

PhoneInput.propTypes = propTypes;

export default PhoneInput;
